import { MutationTree } from "vuex";
import { State } from "@/store/modules/synthetics/secretManager/secretManager.store";

const mutations: MutationTree<State> = {
  setSearchSecretName(state: State, data: any) {
    state.searchSecretName = data;
  },
  setSecretId(state: State, data: any) {
    state.secretId = data;
  },
  setSecretName(state: State, data: any) {
    state.secretName = data;
  },
  setIsSecretDeleteActive(state: State, data: any) {
    state.isSecretDeleteActive = data;
  },
  setSecretPageNum(state: State, data:any) {
    state.secretPageNum = data;
  },
  setSecretSortParams(state: State, data:any) {
    state.secretSortParams = { ...data};
  },
  setDefaultValues(state: State, data:any) {
    state.isSecretDeleteActive = false;
    state.searchSecretName = '';
    state.secretId = '';
    state.secretName = '';
  },
  setIsSecretFormOpen(state: State, data:any) {
    state.isSecretFormOpen = data;
  }
};

export default mutations;
